/**
 * Canonical display formatter for userId values returned by the worker.
 *
 * - Privileged viewers (UNMASKED_EMAIL_VIEWERS) receive the raw email; we
 *   shorten it for table cells while preserving legibility.
 * - Everyone else receives the 64-char email_hash; we prefix it with `usr-`
 *   and show the first 8 hex chars so it reads as an opaque pseudonym.
 */
export function displayUserId(userId: string | null | undefined): string {
  if (!userId) return '—';
  if (userId.includes('@')) {
    // Raw email — shorten for display while keeping it recognizable.
    if (userId.length <= 28) return userId;
    return `${userId.slice(0, 18)}…${userId.slice(-8)}`;
  }
  // Opaque hash (64-char hex from the worker's masking layer).
  return `usr-${userId.slice(0, 8)}`;
}
